import './styles.scss';

//Recebe itens highlight e retorna os elementos card
export function Item({ children }) {
  return (
    <>
      {children}
    </>
  )
}